export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
    label: 'label.no',
    thClass: 'w-50px',
  },
  {
    key: 'name',
    sortable: true,
    sortField: 'name',
    label: 'field.projectName',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'remark',
    sortable: false,
    sortField: 'remark',
    label: 'field.remark',
  },
  {
    key: 'isActive',
    sortable: false,
    sortField: 'isActive',
    label: 'field.status',
  },
  {
    key: 'createdAt',
    sortable: true,
    sortField: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
];